/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { PanelCircuitDataReturnCodes } from '../../models/panel-circuit-data-return-codes';
import { CircuitList } from '../../models/paneldata-info';
import { ValidatePanelCircuitDataSuccess, ChangeApplyPanelDialogSize, ApplyPanelDataSuccess} from './panel-data-actions';
import { createReducer, on } from '@ngrx/store';

export const ApplyPanelDataKey = 'ApplyPanelData';

export interface ApplyPanelDataState {
  projectList: string[];
  panelList: string[];
  circuitList: CircuitList[];
  validSelection: PanelCircuitDataReturnCodes;
  height: number;
  
}

export const InitialPanelDataState: ApplyPanelDataState = {
  projectList: [],
  panelList: [],
  circuitList: [],
  validSelection: PanelCircuitDataReturnCodes.ValidSelection,
  height: 0,
  
};

export const ApplyPanelDataReducer = createReducer(
  InitialPanelDataState, 

  on(ValidatePanelCircuitDataSuccess, (state, action) => ({
    ...state,
    validSelection: action.response,
  })),

  on(ChangeApplyPanelDialogSize, (state, action) => ({
    ...state,
    height: action.height,
  })),
  
  on(ApplyPanelDataSuccess, (state, action) => ({
    ...state,
    validSelection: action.response,
  }))
);